import { differenceInDays, format } from "date-fns";
import { IDateRange } from "./Components/DateRangeSelector";
import { pause } from "../../utils";
import JSZip from "jszip";
import { tMsg } from "../../components/ToastNotifications";
import React from "react";
import { SetStateAction } from "jotai";
import { convertTime, getItemDataFromPath, ILogRowData } from "./utils";
import _ from "lodash";

// const baseUrl = `http://analytics-test-env.eba-8u2bgcmx.ap-southeast-2.elasticbeanstalk.com:8080/analytics`;
const baseUrl = `${process.env.REACT_APP_ANALYTICS_URL}/analytics`;
const fetchZipsUrl = `${baseUrl}/get`;
const fetchDataUrl = `${baseUrl}/ids/list`;

const parseDate = (date: Date): string => {
  return `${format(date, "yyyyMMdd")}+1100`;
};

const getFetchOptions = (
  appId: string,
  deviceIds: string[],
  dateRange: IDateRange
) => {
  const numDays = differenceInDays(dateRange.endDate, dateRange.startDate) + 1;
  const startDay = parseDate(dateRange.startDate);
  // console.log(numDays);
  return {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      appId,
      deviceIds,
      code: "doesn't matter",
      numDays,
      startDay,
    }),
  };
};

const fetchAnalyticsData = async (
  appId: string,
  deviceList: string[],
  dates: IDateRange,
  setLoadStatus?: React.Dispatch<SetStateAction<string | React.ReactNode>>
) => {
  try {
    const response = await fetch(
      fetchZipsUrl,
      getFetchOptions(appId, deviceList, dates)
    ).then((res) => {
      //console.log("response", res);
      return res.blob();
    });
    await pause(100);

    // Extract zip files
    const new_zip = new JSZip();
    const files = await new_zip.loadAsync(response).then((zip: any) => {
      const getFiles = Object.keys(zip.files).reduce((arr: any[], fn) => {
        const file = zip.file(fn);
        if (file) return [...arr, file];
        return arr;
      }, []);
      return getFiles;
    });

    if (setLoadStatus) setLoadStatus("Logs downloaded. Sorting data...");
    await pause(500);

    const getPromises = files.map((file) => {
      return file.async("string").then((s: any) => {
        return s;
      });
    });

    const promiseOfList = Promise.all(getPromises);

    const finalArray = await promiseOfList.then((list) => {
      const result = list.reduce((arr, item) => {
        return [...arr, item];
      }, []);
      return result;
    });

    if (setLoadStatus)
      setLoadStatus(`Loaded ${finalArray.length} days. Parsing data...`);
    await pause(500);

    const parsedRows: ILogRowData[] = finalArray.reduce(
      (arr: ILogRowData[], item: string) => {
        const rows = _.split(item, `\n`).map((row: string) => {
          const data = _.split(row, ",");
          const [logItemData, logItemUrl] = getItemDataFromPath(data[4] || "");
          return {
            time: data[1] ? convertTime(data[1]) : undefined,
            action: data[2],
            button: data[3],
            path: data[4],
            info: data[5] || "",
            logItemData,
            logItemUrl,
          };
        });
        return [...arr, ...rows];
      },
      []
    );

    return parsedRows;
  } catch (err) {
    tMsg.error("Error retrieving analytics data - see console for details");
    console.log(err);
    return [];
  }
};

export default {
  baseUrl,
  fetchZipsUrl,
  fetchDataUrl,
  getFetchOptions,
  fetchAnalyticsData,
};
